module.exports = __webpack_public_path__ + "static/media/happy-review.31d43736.svg";